module.exports = {"TXTWCL_Unlock":{"id":"TXTWCL_Unlock","defaultMessage":"Lås op","flags":["TRACK"],"track":"Unlock"}}